import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleAuditNIS2() {
  return (
    <BlogArticleLayout
      tag="NIS2"
      title="Audit NIS2 : comment préparer votre entreprise"
      date="10 novembre 2026"
      ctaTitle="Évaluez votre préparation face à NIS2"
      ctaText="Le diagnostic évalue vos écarts concrets par rapport aux exigences NIS2 et les intègre dans un plan d'action priorisé."
    >
      <p style={s.intro}>
        Si votre entreprise est concernée par NIS2, un contrôle par les autorités compétentes est une
        possibilité réelle, pas seulement théorique. S'y préparer en amont, plutôt que dans l'urgence, change
        radicalement la façon dont cette échéance est vécue.
      </p>

      <h2 style={s.h2}>Avant tout : confirmer votre statut</h2>
      <p>
        La première étape n'est pas technique mais réglementaire : confirmer si votre entreprise est une
        entité essentielle, une entité importante, ou concernée indirectement en tant que sous-traitant d'une
        entité soumise à NIS2. Voir notre article
        {' '}<Link to="/blog/qui-est-concerne-par-nis2" style={s.link}>Comment savoir si mon entreprise est concernée par NIS2 ?</Link>{' '}
        si ce point n'est pas encore tranché.
      </p>

      <h2 style={s.h2}>Évaluer vos mesures de gestion des risques</h2>
      <p>
        NIS2 exige des mesures proportionnées de gestion des risques pesant sur vos réseaux et systèmes
        d'information. Un audit de préparation consiste à comparer vos pratiques actuelles à ces exigences, en
        s'appuyant sur la même logique que celle décrite dans notre
        {' '}<Link to="/blog/gestion-des-risques-cybersecurite-methode-commune" style={s.link}>article sur la gestion des risques</Link>.
      </p>

      <h2 style={s.h2}>Vérifier la préparation de votre gouvernance</h2>
      <p>
        NIS2 implique directement les organes de direction, qui doivent pouvoir démontrer leur implication
        (approbation des mesures, suivi, formation). Un audit de préparation doit donc vérifier que cette
        implication est réelle et documentée, pas seulement déléguée en silence à un prestataire technique.
      </p>

      <h2 style={s.h2}>Tester votre capacité de déclaration d'incidents</h2>
      <p>
        Les délais de déclaration imposés par NIS2 sont resserrés. Un audit de préparation doit vérifier que
        vous savez concrètement qui alerter, sous quel délai, et avec quelles informations minimales, plutôt
        que de découvrir la procédure le jour d'un incident réel.
      </p>

      <h2 style={s.h2}>Examiner votre chaîne d'approvisionnement</h2>
      <p>
        Vos principaux prestataires et fournisseurs doivent également être passés en revue : quel accès
        ont-ils à vos systèmes, quelles garanties de sécurité offrent-ils, et ces garanties sont-elles
        formalisées contractuellement ?
      </p>

      <h2 style={s.h2}>Documenter votre démarche</h2>
      <p>
        Au-delà des mesures elles-mêmes, être en mesure de démontrer votre démarche (politiques écrites,
        comptes rendus de gouvernance, historique des évaluations de risques) fait partie intégrante de la
        préparation à un contrôle. Voir notre article
        {' '}<Link to="/blog/nis2-pme-ce-qui-change" style={s.link}>NIS2 pour les PME : ce qui change concrètement</Link>{' '}
        pour une vue d'ensemble des obligations à documenter.
      </p>

      <p style={s.disclaimer}>
        Cet article a une vocation informative et ne remplace pas une analyse juridique personnalisée par un
        professionnel du droit.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleAuditNIS2;
